export const PASSWORDS = 'PASSWORDS';
export type PASSWORDS = typeof PASSWORDS;

export const PASSWORDS_SUCCESS = 'PASSWORDS_SUCCESS';
export type PASSWORDS_SUCCESS = typeof PASSWORDS_SUCCESS;

export const PASSWORDS_FAILED = 'PASSWORDS_FAILED';
export type PASSWORDS_FAILED = typeof PASSWORDS_FAILED;

export const PASSWORD_DETAIL = 'PASSWORD_DETAIL';
export type PASSWORD_DETAIL = typeof PASSWORD_DETAIL;

export const PASSWORD_DETAIL_SUCCESS = 'PASSWORD_DETAIL_SUCCESS';
export type PASSWORD_DETAIL_SUCCESS = typeof PASSWORD_DETAIL_SUCCESS;

export const PASSWORD_DETAIL_FAILED = 'PASSWORD_DETAIL_FAILED';
export type PASSWORD_DETAIL_FAILED = typeof PASSWORD_DETAIL_FAILED;

export const PASSWORD_REFERENCES = 'PASSWORD_REFERENCES';
export type PASSWORD_REFERENCES = typeof PASSWORD_REFERENCES;

export const PASSWORD_REFERENCES_SUCCESS = 'PASSWORD_REFERENCES_SUCCESS';
export type PASSWORD_REFERENCES_SUCCESS = typeof PASSWORD_REFERENCES_SUCCESS;

export const PASSWORD_REFERENCES_FAILED = 'PASSWORD_REFERENCES_FAILED';
export type PASSWORD_REFERENCES_FAILED = typeof PASSWORD_REFERENCES_FAILED;

export const PASSWORD_REFERENCES_ENV = 'PASSWORD_REFERENCES_ENV';
export type PASSWORD_REFERENCES_ENV = typeof PASSWORD_REFERENCES_ENV;

export const PASSWORD_REFERENCES_ENV_SUCCESS =
  'PASSWORD_REFERENCES_ENV_SUCCESS';
export type PASSWORD_REFERENCES_ENV_SUCCESS = typeof PASSWORD_REFERENCES_ENV_SUCCESS;

export const PASSWORD_REFERENCES_ENV_FAILED = 'PASSWORD_REFERENCES_ENV_FAILED';
export type PASSWORD_REFERENCES_ENV_FAILED = typeof PASSWORD_REFERENCES_ENV_FAILED;

export const PASSWORD_REFERENCES_VC = 'PASSWORD_REFERENCES_VC';
export type PASSWORD_REFERENCES_VC = typeof PASSWORD_REFERENCES_VC;

export const PASSWORD_REFERENCES_VC_SUCCESS = 'PASSWORD_REFERENCES_VC_SUCCESS';
export type PASSWORD_REFERENCES_VC_SUCCESS = typeof PASSWORD_REFERENCES_VC_SUCCESS;

export const PASSWORD_REFERENCES_VC_FAILED = 'PASSWORD_REFERENCES_VC_FAILED';
export type PASSWORD_REFERENCES_VC_FAILED = typeof PASSWORD_REFERENCES_VC_FAILED;

export const PASSWORD_REFERENCES_SETTINGS = 'PASSWORD_REFERENCES_SETTINGS';
export type PASSWORD_REFERENCES_SETTINGS = typeof PASSWORD_REFERENCES_SETTINGS;

export const PASSWORD_REFERENCES_SETTINGS_SUCCESS =
  'PASSWORD_REFERENCES_SETTINGS_SUCCESS';
export type PASSWORD_REFERENCES_SETTINGS_SUCCESS = typeof PASSWORD_REFERENCES_SETTINGS_SUCCESS;

export const PASSWORD_REFERENCES_SETTINGS_FAILED =
  'PASSWORD_REFERENCES_SETTINGS_FAILED';
export type PASSWORD_REFERENCES_SETTINGS_FAILED = typeof PASSWORD_REFERENCES_SETTINGS_FAILED;
